import 'react-phone-input-2/lib/style.css';

import {
  Card,
  Divider,
  Heading,
  Image,
  SimpleGrid,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';

import { shallow } from 'zustand/shallow';
import { useUIStore } from '#store';
import GLogin from '../GLogin.jsx';
import { PhoneNumber } from '../Contact/PhoneNumber.jsx';
import { VerifyContact } from '../Contact/VerifyContact.jsx';
import { getDims } from '#utils';
import { useEffect } from 'react';

export function Entry() {
  const { putEvent, user, contactStatus } = useUIStore(
    (state) => ({
      putEvent: state.putEvent,
      user: state.user,
      contactStatus: state.contactStatus,
    }),
    shallow
  );
  const { height } = getDims();

  useEffect(() => {
    putEvent({
      type: 'entry',
      data: {
        stage: 'signup-login',
      },
    });
  }, []);

  return (
    <SimpleGrid
      align={'stretch'}
      borderWidth={1}
      borderColor="brand.400"
      templateColumns={['1fr', '1fr 1fr']}
      minH="60vh"
      bg="green.400"
      pb={8}
    >
      <Card
        m={8}
        mb={[4, 8]}
        display={['flex', 'flex']}
        p={6}
        rounded="2xl"
        textAlign="center"
        align={'center'}
      >
        <Image
          src="/public/panda.png"
          fit="contain"
          rounded={'lg'}
          boxSize={[height < 800 ? 28 : 40, 350]}
        ></Image>
        <Text
          fontSize={[height < 800 ? 'md' : 'lg', '2xl']}
          mt={4}
          fontWeight={600}
          color={'gray.700'}
        >
          Login now, because the pandas are already in line for your campsite!
        </Text>
      </Card>
      <VStack
        align={'center'}
        justify="space-evenly"
        px={[2, 10]}
        spacing={[4, 0]}
        mt={[4, 0]}
      >
        <Heading
          color="white"
          spacing={[2, 4]}
          fontSize={['3xl', '5xl']}
          display={['none', 'block']}
        >
          Login / Sign Up
        </Heading>
        {contactStatus !== 'verify' && (
          <>
            <GLogin />
            <Stack direction="row" gap={0} w="90%" align={'center'}>
              <Divider borderColor={'white'} />
              <Text color="white" fontSize={'lg'} fontWeight={500}>OR</Text>
              <Divider borderColor={'white'} />
            </Stack>
          </>
        )}
        {contactStatus === 'verify' ? <VerifyContact /> : <PhoneNumber />}
      </VStack>
    </SimpleGrid>
  );
}
